import { Accordion, AccordionSummary, ListItemText, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Styled } from "./styles";

const Basic = () => {
    return (
        <Accordion disableGutters>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2-content"
                id="panel2-header"
            >
                Basic knowledge
            </AccordionSummary>
            <Styled.AccordionDetails>
                <Typography variant="body2">
                    Starting December 8,<Styled.Bold> Regulation (EU) 2021/2117</Styled.Bold>, which
                    was published on December 2, 2021, will bring about changes to wine and
                    aromatized wine labeling rules. These modifications will necessitate that all
                    wines available in the EU incorporate the following information on their
                    physical and/or digital labels:
                </Typography>
                <Styled.OrderedList>
                    <Styled.ListItem>
                        <ListItemText primary="Energy Values" />
                    </Styled.ListItem>
                    <Styled.ListItem>
                        <ListItemText primary="Intolerances and allergies" />
                    </Styled.ListItem>
                    <Styled.ListItem>
                        <ListItemText primary="Nutritional declaration" />
                    </Styled.ListItem>
                    <Styled.ListItem>
                        <ListItemText
                            primary="
                       List of
                    Ingredients"
                        />
                    </Styled.ListItem>
                </Styled.OrderedList>
                <Typography variant="body2">
                    Wines produced and labeled prior to December 8, 2023, will remain unaffected by
                    these changes and will not require any adjustments to their labels. These wines
                    can continue to be marketed until their existing stock is exhausted.
                </Typography>
                <Styled.Heading>Languages</Styled.Heading>
                <Typography variant="body2">
                    Mandatory information placed on the label (physical or digital) must be provided
                    in all EU languages where the product will be sold. If the wine is sold outside
                    the EU, it must therefore comply with the regulations of the country of
                    destination.
                </Typography>
                <Styled.Heading>
                    How does the digital label manage different lots of wine for the same vintage
                    and varietal? For example, does each bottling/lot require a new QR code and
                    electronic label entry?
                </Styled.Heading>
                <Typography variant="body2">
                    The digital label should be treated as equivalent to the physical label: if all
                    the information on the digital label matches the wine in the bottle, then the
                    same QR code can be used, but if any information on the digital label (such as
                    the vintage year) does not match the wine in the bottle, then a new digital
                    label is required with new QR code. Which means that the digital label can be
                    reused as long as the information about the wine remains unchanged.
                </Typography>
            </Styled.AccordionDetails>
        </Accordion>
    );
};

export default Basic;
